<template>
  <div
    class="help-center-tab__underline"
    :class="className"
  >
    <a
      :href="tab.url"
      class="help-center-tab__link"
    >
      {{ tab.title }}
    </a>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  tab: {
    type: Object,
    required: true
  },
  selectedTab: {
    type: Object,
    required: true
  }
})

const className = computed(() => {
  if (props.tab === props.selectedTab) {
    return 'help-center-tab__underline--selected'
  } else {
    return null
  }
})
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-tab {
  &__underline {
    height: 100%;
    display: flex;
    align-items: center;

    @include help-center-animated-outline(selected, 2px) {
      font-weight: var(--help-center-bold);
    }
  }

  &__link {
    @include help-center-accent-link;
    @include help-center-font(16);
    padding: 4px 0;
  }
}
</style>
